import { Injectable, computed, signal } from '@angular/core';
import { IsoDate, QueryFilter } from '@softline/core';
import { AbcAnalysisBaseMeasure } from '../types/abc-analysis-base-measure';
import { AbcAnalysisOverviewMaster } from '../types/abc-analysis-master';
import { AbcAnalysisOverviewRow } from '../types/abc-analysis-overview-row';

function today(): IsoDate {
  return new Date().toISOString().slice(0, 10) as IsoDate;
}

function startOfYear(): IsoDate {
  return `${new Date().getFullYear()}-01-01` as IsoDate;
}

// Path-parameter state for the abc-analysis endpoints (baseMeasure/abcAnalysisId), plus the
// date range — kept outside the pageFilter FilterState (SOFTLINE_FILTER_WWS_ABC_ANALYSIS,
// see abc-analysis-query.filter.ts) on purpose, mirroring cinema's pattern
// (CinemaStatisticsMenuBarComponent keeps its date range as its own control too): the data
// services combine dateRangeFilter with the pageFilter FilterState's queryFilter() via two
// QueryBuilder.filter() calls (auto-ANDed).
@Injectable()
export class AbcAnalysisFilterStateService {
  readonly baseMeasure = signal<AbcAnalysisBaseMeasure>('CONTRIBUTION_MARGIN');
  readonly abcAnalysisId = signal<number>(1);

  readonly dateFrom = signal<IsoDate>(startOfYear());
  readonly dateTo = signal<IsoDate>(today());

  readonly dateRangeFilter = computed<QueryFilter<AbcAnalysisOverviewRow>>(
    () =>
      ({
        type: 'dateInRange',
        name: 'period',
        valueFrom: this.dateFrom(),
        valueTo: this.dateTo(),
      }) as unknown as QueryFilter<AbcAnalysisOverviewRow>
  );

  readonly master = computed<AbcAnalysisOverviewMaster>(() => ({
    baseMeasure: this.baseMeasure(),
    abcAnalysisId: this.abcAnalysisId(),
  }));
}
